import { useIsOneOfCondition } from '../../hooks';
import { DefaultComparator, IsOneOfComparator } from '../../../../types';
import { useConditionStateContext } from '../../../../contexts';
import { useConditionState } from '../../../../hooks/condition';

export const useComparatorValue = () => {
  const { comparator } = useConditionStateContext();
  const { condition } = useConditionState();
  const isMultiValueCondition = useIsOneOfCondition('values' in condition);

  if (comparator === DefaultComparator.EQUALS && isMultiValueCondition)
    return IsOneOfComparator.IS_ONE_OF;
  if (comparator === DefaultComparator.DOES_NOT_EQUAL && isMultiValueCondition)
    return IsOneOfComparator.IS_NOT_ONE_OF;
  else return comparator ?? null;
};
